import {JSX} from "react";
import {Icon} from "../index";

export default function ValidationRequirement({text, checked}: { text: string, checked: boolean }): JSX.Element {
	return <li className={"form-validation-requirement" + (checked ? " form-validation-checked" : "")}>
		<Icon icon="validation-requirement"/>
		<span>{text}</span>
	</li>;
};
